<template>
  <v-list-item
    class="document-item rounded mx-2 pr-1 mb-2"
    :class="{ 'grey darken-4': $vuetify.theme.dark }"
    :key="item.documentId"
    :to="{ name: 'document', params: { id: item.id } }"
  >
    <v-list-item-content>
      <v-list-item-title class="text-wrap">{{ item.name }}</v-list-item-title>
      <v-list-item-subtitle v-if="item" class="text-caption my-1 text-wrap">
        <span v-if="isMobile">
          <template v-if="showFullDescription">
            {{ item.description }}
          </template>
          <template v-else>
            <div>
              {{ truncatedDescription }}
              <div
                v-if="item.description?.length > truncateLimit"
                class="text-primary font-weight-medium mt-2"
                @click.stop.prevent="showFullDescription = true"
              >
                {{ $t("t_view_more") }}
              </div>
            </div>
          </template>
        </span>
        <span v-else>
          {{ item.description }}
        </span>
      </v-list-item-subtitle>

      <v-list-item-subtitle class="mt-2 text-wrap">
        <div @click.stop.prevent="">
          <tag-chips :tags="tagsToChipsArray" :displayCount="isMobile ? 3 : 10" />
        </div>
      </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>
<script>
import Helpers from "@/mixins/helpers";
import { TagChips } from "@ranes-inc/shared-lib";
export default {
  components: { TagChips },
  name: "DocumentListItem",
  mixins: [Helpers],
  props: {
    item: {
      type: Object,
    },
    parent: {
      type: String,
    },
    tagsList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showFullDescription: false,
      truncateLimit: 60,
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    truncatedDescription() {
      if (!this.item?.description) return "";
      return this.item.description.length > this.truncateLimit
        ? this.item.description.slice(0, this.truncateLimit) + "..."
        : this.item.description;
    },
    tagsToChipsArray() {
      if (!this.item?.tags) return [];

      // If it's already an array, return it
      if (Array.isArray(this.item.tags)) {
        return this.item.tags;
      }

      // If it's a string, split by comma and map to tag objects
      if (typeof this.item.tags === "string") {
        const tagNames = this.item.tags
          .split(",")
          .map((name) => name.trim())
          .filter((name) => name);
        return tagNames.map((name) => {
          // Find matching tag in this.tagsList by name
          const foundTag = this.tagsList?.find((tag) => tag.name === name);
          return foundTag || { name, hexColor: "#757575" }; // fallback color if not found
        });
      }

      return [];
    },
  },
};
</script>
<style lang="scss">
@import "@/scss/variables";

.v-application .documents .document-item {
  border-left: 4px solid $color-documents !important;
}

.text-wrap {
  white-space: normal;
  word-break: break-word;
  overflow: visible;
}
</style>
